import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './RefundPolicy.css';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar isStandalonePage={true} />
      <div className="refund-policy-container">
        <div className="refund-policy-content">
          <h1>Refund Policy</h1>
          <p className="last-updated">Last Updated: 02/01/2025</p>

          <section>
            <h2>Overview</h2>
            <p>At Diagonal Labs LLC (dba Prepkind.com), we sell mock interview credits in fixed bundles (e.g., 5 interviews for $9.99). These credits are for a one-time purchase and are not part of any subscription or recurring plan.</p>
            <p><strong>Important:</strong> All financial transactions are processed by our third-party partner, Paddle, which acts as the Merchant of Record. Any refund that you receive will be issued by Paddle, subject to their Buyer Terms and Refund Policy.</p>
          </section>

          <section>
            <h2>Eligibility for Refunds</h2>
            <p>Because our mock interview credits are delivered digitally and can be used immediately upon purchase, refunds are generally not granted except in the following circumstances:</p>
            
            <h3>Technical Issues:</h3>
            <p>If you are unable to complete or access an interview session due to a technical issue on our platform and we cannot resolve it in a reasonable time, we may:</p>
            <ul>
              <li>Provide you with a replacement access code or additional credits at no extra cost; or</li>
              <li>Approve a refund request if the issue persists and cannot be reasonably resolved for you.</li>
            </ul>

            <h3>Statutory Rights:</h3>
            <p>Where local consumer protection laws require it (e.g., a mandated cooling-off period for digital goods or certain other statutory entitlements), we will honor refunds in accordance with applicable law. Note, however, that once a digital service (mock interview) has been "used" or "consumed," your statutory right of withdrawal may no longer apply.</p>
          </section>

          <section>
            <h2>Non-Refundable Circumstances</h2>
            <h3>Partially or Fully Used Credits:</h3>
            <p>If you have already used some or all of your purchased interview credits, we typically do not issue a refund for those used credits.</p>
            
            <h3>Change of Mind or Personal Reasons:</h3>
            <p>Refunds are not granted simply because a user changes their mind or no longer wishes to use the service.</p>
            
            <h3>Misuse or Violation:</h3>
            <p>If your account is suspended due to violation of our Acceptable Use policy or our Terms of Service, no refund will be issued.</p>
          </section>

          <section>
            <h2>Requesting a Refund</h2>
            <h3>Contact Us First:</h3>
            <p>Email <a href="mailto:contact@prepkind.com">contact@prepkind.com</a> with your Paddle order number (found in your purchase receipt) and a clear explanation of the technical issue or reason for requesting a refund.</p>
            
            <h3>Resolution Attempt:</h3>
            <ul>
              <li>If it's a technical problem, we'll work with you to fix it and, if necessary, provide a replacement code.</li>
              <li>If we can't resolve the issue and you're still within our eligibility guidelines, we will advise you on submitting a refund request via Paddle.</li>
            </ul>

            <h3>Refund Processing by Paddle:</h3>
            <p>Should your request be approved, Paddle will handle the actual payment reversal. Refunds typically appear within 5–10 business days, depending on your payment method.</p>
          </section>

          <section>
            <h2>Chargebacks</h2>
            <p>If you file a chargeback with your bank or card issuer, Paddle will handle the dispute. We reserve the right to suspend or terminate your account if a chargeback is filed without first contacting us to resolve the issue.</p>
            <p>To avoid delays or account suspension, please reach out to us before initiating a chargeback.</p>
          </section>

          <section>
            <h2>Legal and Consumer Rights</h2>
            <p>Depending on where you live, you may have additional rights under local consumer protection laws. We comply with these laws to the extent they apply to one-time digital products like our mock interview credits.</p>
            <p>This policy does not limit any rights you may have under statutory consumer protection law.</p>
          </section>

          <section>
            <h2>Contact Information</h2>
            <p>For questions about this Refund Policy or issues with your mock interview credits, email us at <a href="mailto:contact@prepkind.com">contact@prepkind.com</a>.</p>
            <p>If your refund is approved, or if you have billing-related queries, you can also reach out to Paddle directly through your purchase receipt or via Paddle Support.</p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefundPolicy;
